<template>
  <div class="pull-height">
    <div  class="login-container-before pull-height login-background-img-b" >
    </div>
    <div class="login-container pull-height" @keyup.enter.native="handleLogin">
      <div class="login-info text-white animated fadeInLeft">
        <h2 class="login-info-title">{{title}}</h2>
        <ul class="login-info-list">
          <li class="login-info-item" v-for="(item,index) in list" :key="index">
            <i class="el-icon-check"></i>&nbsp;{{item}}
          </li>
        </ul>
      </div>
      <div class="login-border  animated fadeInRight">
        <div class="login-main">
          <h4 class="login-title"> 邀请注册
          </h4>
          <el-tabs v-model="activeName">
            <el-tab-pane label="短信验证码注册" name="code">
              <codeRegister :agreed="agreed"></codeRegister>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import codeRegister from './codeRegister';
import { mapGetters } from 'vuex';

export default {
  name: 'login',
  components: {
    codeRegister,
  },
  data() {
    return {
      activeName: 'code',
      title: '',
      list: [],
      textMap: {
        create: '主新谷用户协议',
      },
      dialogStatus: '',
      dialogFormContracts: false,
      agreed: false,
    };
  },
  methods: {
    contracts() {
      this.dialogFormContracts = true;
      this.dialogStatus = 'create';
    },
    checkedAgree(newVal) {
      if (this.dialogFormContracts) {
        this.agreed = true;
      }
    },
  },
  created() {
    // this.title = this.website.platform.title;
    // this.list = this.website.platform.list;
  },
  mounted() {},
  computed: {
    ...mapGetters(['website']),
  },
  props: [],
};
</script>

<style lang="scss">
.login-container {
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: rgba(0, 0, 0, 0.3);
  position: relative;
}
.login-background-img-b{
  background-image: url('https://www.howdohr.com/zuul/file/10008');
}
.login-container-before {
  z-index: -999;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
}
.login-info {
  padding-left: 60px;
}
.login-info-title {
  line-height: 90px;
}
.login-info-item {
  font-size: 14px;
}
.login-border {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 30px 40px 25px 40px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 2px #eee;
}
.welcome{
  text-shadow: 0px 1px 3px #1ea0ff;
  position: relative;
  z-index: 9;
}
.login-main {
  border-radius: 3px;
  box-sizing: border-box;
  background-color: #fff;
}
.login-main > h3 {
  margin-bottom: 20px;
}
.login-main > p {
  color: #76838f;
}
.login-title {
  margin: 0 0 20px;
  text-align: center;
  color: #409eff;
  letter-spacing: 3px;
}
.login-submit {
  width: 100%;
  background: #3080fe;
}
.login-form {
  margin: 10px 0;
  .el-form-item__content {
    width: 270px;
  }
  .el-form-item {
    /*margin-bottom: 25px;*/
  }
  .el-input {
    input {
      text-indent: 5px;
      border-color: #dcdcdc;
      border-radius: 3px;
    }
    .el-input__prefix {
      i {
        padding: 0 5px;
        font-size: 16px !important;
      }
    }
  }
}
.login-code {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 0 0 10px;
}
.login-code-img {
  width: 100px;
  height: 38px;
  background-color: #fdfdfd;
  border: 1px solid #f0f0f0;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 5px;
  line-height: 32px;
  text-indent: 5px;
  text-align: center;
}
.contract{
  font-size: 12px;
  padding: 0 10px;
}

.footer-copyright{
  font-size: 12px;
  color: white;
  text-align: center;
  z-index: 12;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  float: bottom;
}
</style>
